import React from 'react';
import Box from 'carbon-react/lib/components/box';

import type { InsightsVariant } from '../../ai-insights';
import type { MappedHighlightMetric, MappedKpiMetric } from '../../mappers/types';
import { HighlightMetricCards } from '../highlight-metric-card/highlight-metric-card';
import { KpiMetricCards } from '../kpi-metric-card/kpi-metric-card';

interface MetricCardsSectionProps {
  variant: InsightsVariant;
  kpiMetrics?: MappedKpiMetric[];
  highlightMetrics?: MappedHighlightMetric[];
}

export const MetricCardsSection = ({ variant, kpiMetrics, highlightMetrics }: MetricCardsSectionProps) => {
  if (variant === 'accountant' && kpiMetrics && kpiMetrics.length > 0) {
    return (
      <Box mb={3}>
        <KpiMetricCards metrics={kpiMetrics} />
      </Box>
    );
  }

  if (variant !== 'accountant' && highlightMetrics && highlightMetrics.length > 0) {
    return (
      <Box mb={3}>
        <HighlightMetricCards metrics={highlightMetrics} />
      </Box>
    );
  }

  return null;
};
